import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import RebrandLogo from '@zola/zola-ui/src/assets/images/rebrand/zola-logomark-marine.svg';

const NavLogo = ({ className, logo }) => {
  const determineZolaLogo = () => {
    if (logo) {
      return logo;
    }
    return RebrandLogo;
  };

  return (
    <div className={cx('nav-logo', className)}>
      <a href="/" target="_self" aria-label="Zola Homepage" data-testid="nav-logo">
        <img
          src={determineZolaLogo()}
          alt="Zola Homepage"
          className={cx('nav-logo__img', 'nav-rebrand-logo')}
        />
      </a>
    </div>
  );
};

NavLogo.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
};

export default NavLogo;
